import { TrackedDriverTimeType } from '@/api/main/types.gen'
import { Badge, MantineTheme, useMantineTheme } from '@mantine/core'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const getStateColor = (theme: MantineTheme, state?: TrackedDriverTimeType) => {
  switch (state) {
    case 'between_drives':
      return theme.colors.blue[6]
    case 'patrol':
      return theme.colors.green[6]
    case 'on_break':
      return theme.colors.red[6]
    case 'maintenance':
      return theme.colors.yellow[6]
    default:
      return theme.colors.gray[6]
  }
}

const getStateLabelKey = (state?: TrackedDriverTimeType) => {
  switch (state) {
    case 'between_drives':
      return 'stateBetween'
    case 'patrol':
      return 'statePatrol'
    case 'on_break':
      return 'stateBreak'
    case 'maintenance':
      return 'stateMaintenance'
    default:
      return 'stateUnknown'
  }
}

const VehicleStateBadge: FC<{ state?: TrackedDriverTimeType; goToGarage?: boolean }> = ({ state, goToGarage }) => {
  const theme = useMantineTheme()
  const { t } = useTranslation('vehicles')

  const styles = {
    root: {
      backgroundColor: getStateColor(theme, state),
      marginBottom: 4,
    },
  }

  if (goToGarage) {
    return (
      <Badge styles={{ root: { marginBottom: 4 } }} size="sm" color={theme.colors.grape[6]}>
        {t('stateToGarage')}
      </Badge>
    )
  }

  if (!state) {
    return (
      <Badge styles={styles} size="sm">
        {t('stateUnknown')}
      </Badge>
    )
  }

  return (
    <Badge styles={styles} size="sm">
      {t(getStateLabelKey(state) as Parameters<typeof t>[0])}
    </Badge>
  )
}

export default VehicleStateBadge
